/**
 * Web shim for react-native-linear-gradient.
 *
 * Renders a CSS linear-gradient inside a react-native-web View, mapping
 * the `colors`, `start`, and `end` props to the equivalent CSS direction.
 * All other gradient props (locations, useAngle, angleCenter) are accepted
 * and silently ignored for simplicity — extend as needed.
 */

import React from 'react';
import { View } from 'react-native';

const LinearGradient = ({
  colors = ['transparent', 'transparent'],
  start = { x: 0, y: 0 },
  end = { x: 1, y: 0 },
  style,
  children,
  ...rest
}) => {
  // Convert start/end unit vectors to a CSS angle or keyword.
  const dx = end.x - start.x;
  const dy = end.y - start.y;
  let direction;
  if (Math.abs(dx) <= 0.01) {
    direction = dy >= 0 ? 'to bottom' : 'to top';
  } else if (Math.abs(dy) <= 0.01) {
    direction = dx >= 0 ? 'to right' : 'to left';
  } else {
    // General case: convert vector to CSS angle (clockwise from top).
    const angleDeg = Math.round(Math.atan2(dx, -dy) * (180 / Math.PI));
    direction = `${angleDeg}deg`;
  }

  const gradient = `linear-gradient(${direction}, ${colors.join(', ')})`;

  return React.createElement(
    View,
    {
      ...rest,
      style: [
        style,
        {
          backgroundImage: gradient,
          // react-native-web passes unknown style keys to the DOM,
          // so we use the vendor-prefixed form explicitly for safety.
          background: gradient,
        },
      ],
    },
    children,
  );
};

export default LinearGradient;
